<template lang="pug">
  sui-segment(vertical)
    sui-grid
      sui-grid-row
        sui-grid-column
          sui-table(
            unstackable,
            single-line)
            sui-table-header
              sui-table-row
                sui-table-header-cell #
                sui-table-header-cell Team Name
                sui-table-header-cell W
                sui-table-header-cell L
                sui-table-header-cell MP
                sui-table-header-cell MAP W-L-T

            sui-table-body
              sui-table-row(
                v-for="team, i in teams"
                :key="team.teamId",
                :positive="i < teams.length / 2",
                :negative="i >= teams.length / 2")
                sui-table-cell {{ i + 1 }}
                sui-table-cell {{ team.name }}
                sui-table-cell {{ team.standings.league.matchWin }}
                sui-table-cell {{ team.standings.league.matchLoss }}
                sui-table-cell.
                  {{ team.standings.league.matchWin + team.standings.league.matchLoss }}

                sui-table-cell.
                  {{ team.standings.league.gameWin }}
                  -
                  {{ team.standings.league.gameLoss }}
                  -
                  {{ team.standings.league.gameTie }}
</template>

<script>
export default {
  name: 'StandingTable',
  props: {
    teams: {
      required: true,
    },
  },
};
</script>
